import gqls from "@/graphql/paySet.gql";
import { httpServer as http } from "@/lib/axios";

// callback 调用
import { resRest, easyMutate } from "@root/lib/utils";

import BbqActions from "@root/lib/bbqActions";
// console.log(Object.assign(gqls, getAttr), "Object.assign(gqls, getAttr)");
const shortAction = new BbqActions(gqls, []);
const gqlActions = shortAction.getValues();

const paySet = {
  namespaced: true,
  state: {
    SPLITBILL_STATUS_MAP: {
      0: "未分账",
      1: "已分账",
      2: "分账失败",
      3: "分账中"
    },
    PAY_CHANNEL_STATUS_MAP: {
      0: "支付失败",
      1: "支付成功"
    },
    CONFIRMATION_STATUS_MAP: {
      0: "未确权",
      1: "确权成功",
      2: "确权失败",
      3: "确权中"
    },
    VIRTUAL_ACCOUNT_STATUS: {
      0: "冻结",
      1: "正常使用中"
    },
    // 资金状态（确权状态）
    CONFIRM_RIGHT_STATUS: {
      0: "待入账",
      1: "已入账",
      2: "待入账",
      3: "待入账"
    },
    // 企业号类型
    companyNoTypeOptions: [
      { label: "企业注册号", value: "10" },
      { label: "统一社会信用代码", value: "20" }
    ],
    // 商户类型
    merchantTypeOptions: [
      { label: "企业", value: "C" },
      { label: "自然人", value: "P" }
    ],
    // 商户类型
    merchantTypeMap: {
      C: "企业",
      P: "自然人"
    },
    profitabilityOptions: [
      { label: "营利性组织", value: "YL" },
      { label: "非营利性组织", value: "NP" }
    ],
    // 法人（自然人）有效证件类型
    corporateNoTypeOptions: [
      {
        label: "身份证",
        value: "1"
      },
      {
        label: "军官证",
        value: "2"
      },
      {
        label: "护照",
        value: "3"
      },
      {
        label: "户口簿",
        value: "4"
      },
      {
        label: "士兵证",
        value: "5"
      },
      {
        label: "港澳来往内地通行证",
        value: "6"
      },
      {
        label: "台湾同胞来往内地通行证",
        value: "7"
      },
      {
        label: "临时身份证",
        value: "8"
      },
      {
        label: "外国人居留证",
        value: "9"
      },
      {
        label: "警官证",
        value: "10"
      },
      {
        label: "其他",
        value: "11"
      }
    ],
    CURRENCY: "cny",
    CHANNELTYPE: "cmb-w", // 支付渠道
    PAYMENT_TYPE: "withdraw", // 支付方式
    PLATFORM_USERCODE: "C0007746", // 平台渠道用户编码
    ACCOUNT_TYPE: "101" // 招行
  },
  getters: {},
  actions: {
    ...gqlActions,
    // 支付金管理-账号信息查询接口
    async querySonAccountInfo({ rootState }, params = {}) {
      const data = await http("/k1/wallet/cmb/querySonAccountInfo", params);

      return data ? data.data : {};
    }
  },
  mutations: {
    easyMutate
  }
};
export default paySet;
